export function obterListaClassificacaoIBSZFM() {
  return (
    [
      { label: '', value: null },
      { label: '0 Sem Crédito Presumido', value: 'SEMCREDITO' },
      { label: '1 Bens de Consumo Final (55%)', value: 'BENSFINAL' },
      { label: '2 Bens de Capital (75%)', value: 'BENSCAPITAL' },
      { label: '3 Bens Intermediários (90,25%)', value: 'BENSINTERMEDIARIO' },
      { label: '4 Bens de Informática e outros definidos em legislação (100%)', value: 'OUTROSBENS' },
    ]
  );
}
